import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material"
import { Button, ButtonProps } from "@mui/material"
import { makeStyles } from "tss-react/mui-compat"
import React from "react"

const useStyles = makeStyles()(
  (theme) => ({
    button: {
      color: theme.palette.primary.darkest,
      "&:hover": {
        backgroundColor: theme.palette.primary.light,
      },
      // change ripple effect color
      "& > .MuiTouchRipple-root span": {
        backgroundColor: theme.palette.primary.light,
      },
    },
  })
)

interface DropdownButtonProps {
  isOpen: boolean
  children: ButtonProps["children"]
  onClick: ButtonProps["onClick"]
  ariaControls?: string
}

export const DropdownButton = React.forwardRef<HTMLButtonElement, DropdownButtonProps>(
  function DropdownButton(props, ref) {
    const { isOpen, onClick, children, ariaControls } = props
    const { classes } = useStyles()

    return (
      <Button
        color="inherit"
        className={classes.button}
        ref={ref}
        aria-controls={ariaControls}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        onClick={onClick}
        endIcon={isOpen ? <ArrowDropUp /> : <ArrowDropDown />}>
        {children}
      </Button>
    )
  },
)
